import React, { Component } from "react";
import PropTypes from "prop-types";
import { isMobile as isMobileDetected, CustomView } from "react-device-detect";
import { injectIntl } from "gatsby-plugin-intl";
import DesktopContainer from "./DesktopContainer";
import MobileContainer from "./MobileContainer";
import SEO from "./seo";
import Footer from "./Footer";
import { ThemeContext } from "../store/theme";

if (!global.Intl) {
  global.Intl = require("intl"); //eslint-disable-line
}
class ResponsiveContainer extends Component {
  static contextType = ThemeContext;

  state = {
    isMobile: false,
  };

  componentDidMount() {
    // on client side we check if we are on mobile
    // or not
    this.setState({
      isMobile: isMobileDetected,
    });
  }

  render() {
    const { isMobile } = this.state;
    const { children, intl, landing, buy, help, offer } = this.props;

    // if (process.env.GATSBY_KOREAN !== "true" && intl.locale === "ko") {
    //   if (typeof window !== "undefined") {
    //     window.location.href = "https://picpick.net";
    //     return null;
    //   }
    // }

    return (
      <>
        <CustomView condition={!isMobile}>
          <DesktopContainer
            offer={offer}
            help={help}
            buy={buy}
            landing={landing}
          >
            {children}
          </DesktopContainer>
        </CustomView>
        <CustomView condition={isMobile}>
          <MobileContainer buy={buy} landing={landing}>
            {children}
          </MobileContainer>
        </CustomView>
      </>
    );
  }
}

ResponsiveContainer.propTypes = {
  landing: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

const Layout = (
  { children, landing, buy, intl, offer } // eslint-disable-line
) => (
  <ResponsiveContainer intl={intl} offer={offer} buy={buy} landing={landing}>
    <SEO />
    {children}
    <Footer />
  </ResponsiveContainer>
);

Layout.propTypes = {
  landing: PropTypes.bool,
  offer: PropTypes.bool,
  children: PropTypes.node.isRequired,
  ad: PropTypes.bool,
};

Layout.defaultProps = {
  landing: false,
  offer: false,
  ad: true,
};

export default injectIntl(Layout);
